module.exports = __webpack_public_path__ + "img/esrb-rating-icon.d5672325.svg";